<template>
  <va-create-layout>
    <about-incocegla-form :title="title" :item="item"></about-incocegla-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
